<template>
  <div>
    <div class="overflow-hidden">
      <div class="float-left" style="width: 128px; overflow-y: auto">
        <div class="pt-6" style="min-height: calc(100vh - 135px)">
          <Menu :selectedKeys="[6]"></Menu>
        </div>
      </div>
      <div class="float-right p-6" style="width: calc(100% - 128px)">
        <a-spin :spinning="spinning">
          <div>
            <div class="pb-6 overflow-hidden">
              <div class="float-left overflow-hidden">
                <span class="float-left pr-2 leading-8">搜索:</span>
                <a-textarea
                  class="float-left"
                  style="width: 200px"
                  autoSize
                  v-model="queryParam.custom.search"
                  placeholder="请输入要搜索的内容"
                  @pressEnter="press_enter"
                ></a-textarea>
              </div>
              <div class="float-left pl-6 overflow-hidden">
                <span class="float-left pr-2 leading-8">出函日期:</span>
                <a-range-picker
                  class="float-left"
                  v-model="queryParam.time.sign_time"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                />
              </div>
              <div class="float-left pl-6">
                <a-button type="primary" class="mr-2" @click="gets(1)">搜索</a-button>
                <a-button type="default" @click="reset">重置</a-button>
              </div>
              <div class="float-right">
                <a-button
                  type="primary"
                  @click="exportbilling"
                  v-if="permission(['report', 'linhai'], 'export_contract')"
                  >导出报表</a-button
                >
              </div>
            </div>
            <div>
              <a-row :gutter="[24, 24]">
                <a-col :span="8">
                  <a-card>
                    <a-statistic title="总数" :value="rs.count" />
                  </a-card>
                </a-col>
                <a-col :span="8">
                  <a-card>
                    <a-statistic title="总担保费" :value="poundage" :precision="2" />
                  </a-card>
                </a-col>
                <a-col :span="8">
                  <a-card>
                    <a-statistic title="总担保金额" :value="money" :precision="2" />
                  </a-card>
                </a-col>
              </a-row>
            </div>
            <a-table
              :loading="loading"
              :columns="columns"
              :data-source="list"
              :pagination="pagination"
              bordered
              row-key="id"
              size="small"
              :scroll="{ x: 2950 }"
              ><template slot="code" slot-scope="text, record">
                <text-highlight :queries="[search]" :title="text">
                  {{ record.prefix + text }}</text-highlight
                >
              </template>
              <template slot="proprietor" slot-scope="text">
                <text-highlight :queries="[search]" :title="text"> {{ text }}</text-highlight>
              </template>
              <template slot="bidder" slot-scope="text">
                <text-highlight :queries="[search]" :title="text"> {{ text }}</text-highlight>
              </template>
              <template slot="project" slot-scope="text">
                <text-highlight :queries="[search]" :title="text"> {{ text }}</text-highlight>
              </template>
              <template slot="status" slot-scope="text">
                <span :class="findByKey(contractStatus, 'id', text, 'color')">{{
                  findByKey(contractStatus, 'id', text, 'name')
                }}</span>
              </template>
              <template slot="action" slot-scope="text, record">
                <span v-if="permission(['report', 'wenling'], 'edit')">
                  <a @click="edit(record)" class="text-yellow-500">编辑</a>
                  <!-- <a-divider type="vertical"></a-divider>
                  <a @click="editrecord(record)" class="text-green-500">编辑记录</a> -->
                </span>
              </template>
            </a-table>
          </div>
        </a-spin>
      </div>
    </div>
    <MForm :visible="editFlag" :info="editInfo" @cancel="editFlag = false" @ok="gets(1)"></MForm>
    <EditRecord
      :visible="editRecordFlag"
      :info="editRecordInfo"
      @cancel="editRecordFlag = false"
    ></EditRecord>
  </div>
</template>
<script>
  import Menu from '@/views/admin/menu/index.vue';
  import { findByKey } from '@/utils/tool';
  import { columns } from './_list';
  import {
    contracts_wenling,
    contract_wenling_statistics,
    contract_statuss,
    exportContractWenling,
  } from '@/api/contract';
  import permission from '@/utils/permission';
  import { downloadUrl } from '@/utils/download';
  import MForm from './module/form.vue';
  import EditRecord from './module/editRecord.vue';
  export default {
    components: {
      Menu,
      MForm,
      EditRecord,
    },
    data() {
      return {
        columns,
        queryParam: { custom: { search: '' }, time: {} },
        pagination: {
          current: 1,
          hideOnSinglePage: true,
          onChange: (page) => {
            this.pagination.current = page;
            this.gets();
          },
        },
        list: [],
        loading: true,
        contractStatus: [],
        spinning: false,
        editFlag: false,
        editInfo: {},
        editRecordFlag: false,
        editRecordInfo: {},
        search: '',
        rs: {},
      };
    },
    computed: {
      poundage() {
        let total = this.rs.poundage_sum;
        // let totalw = total / 10000;
        // if (totalw > 0) {
        //   return totalw.toFixed(2) + '万';
        // }
        return total;
      },
      money() {
        let total = this.rs.money_sum;
        let totalw = total / 10000;
        if (totalw > 0) {
          if (totalw > 10000) {
            return (totalw / 10000).toFixed(2) + '亿';
          } else {
            return totalw.toFixed(2) + '万';
          }
        }
        return total;
      },
    },
    async mounted() {
      this.contractStatus = (await contract_statuss({ current: -1 })).data || [];
    },
    activated() {
      this.gets();
    },
    methods: {
      findByKey,
      permission,
      async gets(current) {
        this.loading = true;
        if (current) {
          this.pagination.current = current;
        }
        this.search = this.queryParam.custom.search;
        let res = await contracts_wenling({
          current: this.pagination.current,
          qp: JSON.stringify(this.queryParam),
        });
        this.list = res.data || [];
        this.$set(this.pagination, 'total', res.total);
        this.loading = false;
        this.rs = await contract_wenling_statistics({
          qp: JSON.stringify(this.queryParam),
        });
      },
      reset() {
        this.queryParam = { custom: { search: '' }, time: {} };
        this.gets(1);
      },
      press_enter(e) {
        e.preventDefault();
        this.gets(1);
      },
      async exportbilling() {
        this.spinning = true;
        const url = await exportContractWenling({
          qp: JSON.stringify(this.queryParam),
        });
        downloadUrl(this.$ossUrl + '/' + url, '报表列表.xlsx');
        this.spinning = false;
      },
      edit(record) {
        this.editInfo = record;
        this.editFlag = true;
      },
      editrecord(record) {
        this.editRecordInfo = record;
        this.editRecordFlag = true;
      },
    },
  };
</script>
